export default __webpack_public_path__ + "static/media/heading-background.c81f7cec.png";